/**
 * Wizard venue select / session stash / waitlist (from flow.attach).
 * Resets live cursors via S.resetLiveCursors — do not copy lastLive* primitives.
 */
(function (global) {
  'use strict';
  if (global.WorkshopBookingWizardFlowVenue) return;
  global.WorkshopBookingWizardFlowVenue = {
    attach: function (S) {
      if (!S) return;
      var bookingRoot = S.bookingRoot;
      var eventsRoot = S.eventsRoot;
      var isStoreVenue = S.isStoreVenue;
      var resolveVenueDisplayLabel = S.resolveVenueDisplayLabel;
      var setBranch = S.setBranch;
      var slotDateKey = S.slotDateKey;
      var slotVisible = S.slotVisible;
      var state = S.state;
      var stepEl = S.stepEl;
      var syncVenueKindAttr = S.syncVenueKindAttr;
      var updateBranchTitles = S.updateBranchTitles;
      var updateProductVenueSeoCopy = S.updateProductVenueSeoCopy;
      var updateProgressLabels = S.updateProgressLabels;
      var updateWizardBookingUrl = S.updateWizardBookingUrl;
      var urlHasWizardDeepLink = S.urlHasWizardDeepLink;
      var venueIsWaitlistOnly = S.venueIsWaitlistOnly;
      var venueLabelForWizard = S.venueLabelForWizard;
      var wizardRoot = S.wizardRoot;

      function applyDatetimeSelectionAfterSlots(opts) {
        if (typeof S.applyDatetimeSelectionAfterSlots === 'function') S.applyDatetimeSelectionAfterSlots(opts);
      }
      function slotsForDate(key) {
        return typeof S.slotsForDate === 'function' ? S.slotsForDate(key) : [];
      }
      function slotSyncKey(slot) {
        return typeof S.slotSyncKey === 'function' ? S.slotSyncKey(slot) : '';
      }
      function resetDatetimeControlsDom() {
        if (typeof S.resetDatetimeControlsDom === 'function') S.resetDatetimeControlsDom();
      }
      function prefetchVenueCalendar(venue) {
        if (typeof S.prefetchVenueCalendar === 'function') S.prefetchVenueCalendar(venue);
      }
      function startDatetimeStep() {
        return typeof S.startDatetimeStep === 'function' ? S.startDatetimeStep() : Promise.resolve();
      }
      function startPopupBookingStep() {
        return typeof S.startPopupBookingStep === 'function' ? S.startPopupBookingStep() : Promise.resolve();
      }
      function setDatetimeCalLoading(on, msg) {
        if (typeof S.setDatetimeCalLoading === 'function') S.setDatetimeCalLoading(on, msg);
      }
      function setPopupDatetimeLoading(on) {
        if (typeof S.setPopupDatetimeLoading === 'function') S.setPopupDatetimeLoading(on);
      }
      function setPopupDatetimeHint(msg, isError) {
        if (typeof S.setPopupDatetimeHint === 'function') S.setPopupDatetimeHint(msg, isError);
      }
      function syncAtcReminder() {
        if (typeof S.syncAtcReminder === 'function') S.syncAtcReminder();
      }
      function syncSiblingWorkshopPromo() {
        if (typeof S.syncSiblingWorkshopPromo === 'function') S.syncSiblingWorkshopPromo();
      }
      function resetLiveCursors() {
        if (typeof S.resetLiveCursors === 'function') S.resetLiveCursors();
      }

    function findVenueCardByRef(refId) {
      var want = String(refId || '').trim();
      if (!want || !eventsRoot) return null;
      var cards = eventsRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card');
      for (var i = 0; i < cards.length; i++) {
        var c = cards[i];
        var cref = String((c && c.getAttribute && c.getAttribute('data-venue-ref-id')) || '').trim();
        if (cref && cref === want) return c;
        if (c && c._wbVenue && String(c._wbVenue.venue_ref_id || '').trim() === want) return c;
      }
      return null;
    }

    function rebindSelectedVenueCard() {
      if (!state.selectedVenue) return null;
      var card = state.selectedVenueCard;
      if (card && eventsRoot && eventsRoot.contains(card) && card._wbVenue) return card;
      var ref = String(state.selectedVenue.venue_ref_id || '').trim();
      var next = findVenueCardByRef(ref);
      if (!next || !next._wbVenue) return null;
      var prev = state.selectedVenue;
      state.selectedVenueCard = next;
      state.selectedVenue = next._wbVenue;
      if (prev && prev !== state.selectedVenue) {
        if (Array.isArray(prev.events) && prev.events.length) {
          if (!Array.isArray(state.selectedVenue.events) || !state.selectedVenue.events.length) {
            state.selectedVenue.events = prev.events;
          }
        }
        if (prev._wbLoadedMonths) {
          if (!state.selectedVenue._wbLoadedMonths) {
            state.selectedVenue._wbLoadedMonths = Object.create(null);
          }
          Object.keys(prev._wbLoadedMonths).forEach(function (ym) {
            state.selectedVenue._wbLoadedMonths[ym] = true;
          });
        }
      }
      if (state.selectedVenue.has_events !== true && state.flow !== 'waitlist') {
        state.flow = venueIsWaitlistOnly(state.selectedVenue, next) ? 'waitlist' : 'booking';
        wizardRoot.setAttribute('data-wbw-flow', state.flow);
      }
      next.classList.add('wbw-venue-selected');
      next.setAttribute('aria-pressed', 'true');
      return next;
    }

    function updateVenueContinue() {
      var btn = wizardRoot.querySelector('[data-wbw-action="to-next"]');
      if (!btn) return;
      rebindSelectedVenueCard();
      var valid =
        !!state.selectedVenue &&
        state.flow !== 'waitlist' &&
        state.selectedVenue.has_events === true &&
        !!String(state.selectedVenue.venue_ref_id || '').trim();
      if (typeof S.setCtaValidity === 'function') {
        S.setCtaValidity(btn, valid, wizardRoot.querySelector('[data-wbw-cta-hint="venue"]'));
      } else {
        btn.disabled = !valid;
      }
      syncAtcReminder();
    }

    function syncVenueFlipState() {
      if (!eventsRoot) return;
      eventsRoot.querySelectorAll('.wbw-venue-flip-card').forEach(function (c) {
        c.classList.remove('wbw-venue-flipped');
      });
      var card = state.selectedVenueCard;
      if (
        card &&
        card.classList &&
        card.classList.contains('wbw-venue-flip-card') &&
        card.classList.contains('wbw-venue-selected') &&
        state.flow === 'waitlist'
      ) {
        card.classList.add('wbw-venue-flipped');
      }
    }

    function closeWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('hidden', '');
      modal.setAttribute('aria-hidden', 'true');
    }

    function openWizardWaitlistModal() {
      var modal = wizardRoot.querySelector('[data-wbw-wl-modal]');
      if (!modal) return;
      var vn = venueLabelForWizard();
      var title = modal.querySelector('[data-wbw-wl-modal-title]');
      if (title) {
        title.textContent = vn
          ? 'No workshops scheduled for ' + vn + ' yet'
          : 'No workshops scheduled yet';
      }
      var err = modal.querySelector('[data-wbw-wl-modal-error]');
      var ok = modal.querySelector('[data-wbw-wl-modal-success]');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      if (ok) ok.hidden = true;
      ['[data-wbw-wl-modal-name]', '[data-wbw-wl-modal-email]', '[data-wbw-wl-modal-notes]'].forEach(function (sel) {
        var el = modal.querySelector(sel);
        if (el) el.value = '';
      });
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      var nameIn = modal.querySelector('[data-wbw-wl-modal-name]');
      try {
        if (nameIn) nameIn.focus();
      } catch (_) {}
    }

    function wbwEmitVenueMapSelection(venue) {
      if (!venue || typeof venue !== 'object') return;
      var lat = venue.venue_lat != null ? venue.venue_lat : venue.lat != null ? venue.lat : venue.latitude;
      var lng = venue.venue_lng != null ? venue.venue_lng : venue.lng != null ? venue.lng : venue.longitude;
      lat = lat != null && lat !== '' ? Number(lat) : NaN;
      lng = lng != null && lng !== '' ? Number(lng) : NaN;
      var city = String(venue.city || venue.city_name || venue.venue_city || '').trim();
      var state = String(venue.state || venue.state_code || venue.region_code || '').trim();
      var zip = String(venue.zip || venue.postal_code || venue.postcode || '').trim();
      var street = String(venue.venue_address || venue.address || venue.street || '').trim();
      var address = street;
      if (!address) {
        address = [city, state].filter(Boolean).join(', ');
        if (address && zip) address += ' ' + zip;
      } else if (city && address.toLowerCase().indexOf(city.toLowerCase()) === -1) {
        address = address + ', ' + city + (state ? ', ' + state : '') + (zip ? ' ' + zip : '');
      }
      var detail = {
        title: String(venue.venue_name || venue.name || city || '').trim(),
        address: address,
        city: city,
        state: state,
        zip: zip,
        region_code: state,
        state_code: state,
        lat: Number.isFinite(lat) ? lat : null,
        lng: Number.isFinite(lng) ? lng : null,
        location_id: String(venue.location_id || '').trim(),
        facilities: Array.isArray(venue.facilities) ? venue.facilities : [],
        wheelchair_accessible: venue.wheelchair_accessible === true,
        accessible_toilets: venue.accessible_toilets === true,
        ground_level: venue.ground_level === true,
        accessible_parking: venue.accessible_parking === true || venue.accessible_parking_spot === true,
        lift_to_all_floors: venue.lift_to_all_floors === true,
      };
      if (!detail.title && !detail.address && !detail.city && detail.lat == null) return;
      try {
        document.dispatchEvent(new CustomEvent('wbw:venue-selected', { detail: detail }));
      } catch (_) {}
    }

    function venueSessionKey(venue) {
      return venue ? String(venue.venue_ref_id || '').trim() : '';
    }

    function clonePlainMap(obj) {
      var out = {};
      if (!obj) return out;
      Object.keys(obj).forEach(function (k) {
        var v = obj[k];
        if (v && typeof v === 'object') {
          out[k] = {
            dateKey: v.dateKey || '',
            gid: v.gid || '',
          };
        } else {
          out[k] = v;
        }
      });
      return out;
    }

    function peekVenueSession(venue) {
      var key = venueSessionKey(venue);
      return key && state.sessionByVenue ? state.sessionByVenue[key] || null : null;
    }

    function stashVenueSession(venue) {
      var key = venueSessionKey(venue);
      if (!key) return;
      if (!state.sessionByVenue) state.sessionByVenue = {};
      var slot = state.selectedSlot;
      state.sessionByVenue[key] = {
        selectedDate: String(state.selectedDate || ''),
        slotGid: slot && slot.gid ? String(slot.gid) : '',
        slotSyncKey: slot ? String(slotSyncKey(slot) || '') : '',
        variantQty: clonePlainMap(state.variantQty),
        variantWhen: clonePlainMap(state.variantWhen),
        focusedVariantId: String(state.focusedVariantId || ''),
        lockedVariantId: String(state.lockedVariantId || ''),
        userPickedCalDate: !!state._wbwUserPickedCalDate,
        viewMonth:
          state.viewMonth instanceof Date ? state.viewMonth.getTime() : 0,
      };
    }

    function applySavedVenueSession(saved) {
      if (!saved || !(saved.selectedDate || saved.slotGid || saved.slotSyncKey)) {
        applyDatetimeSelectionAfterSlots({
          priorDate: '',
          priorGid: '',
          deepLinkSlot: null,
          allowDeepLink: false,
          syncViewMonth: false,
        });
        return;
      }
      applyDatetimeSelectionAfterSlots({
        priorDate: saved.selectedDate || '',
        priorGid: saved.slotGid || '',
        deepLinkSlot: null,
        allowDeepLink: false,
        syncViewMonth: !!saved.selectedDate,
      });
      if (!state.selectedSlot && saved.slotSyncKey) {
        var list = saved.selectedDate ? slotsForDate(saved.selectedDate) : state.slotList || [];
        for (var i = 0; i < list.length; i++) {
          if (slotSyncKey(list[i]) === saved.slotSyncKey && slotVisible(list[i])) {
            state.selectedSlot = list[i];
            if (!state.selectedDate) state.selectedDate = slotDateKey(list[i]) || saved.selectedDate;
            break;
          }
        }
      }
    }

    function clearVenueSelection(options) {
      options = options || {};
      state.selectedVenueCard = null;
      state.selectedVenue = null;
      state._wbDatetimeVenueRef = '';
      state.flow = 'booking';
      state.slotList = [];
      state.selectedDate = '';
      state.selectedSlot = null;
      state.variantWhen = {};
      state.lbEditVariant = '';
      state.lbApplyAll = null;
      state.lbAskApply = false;
      // Reset live cursors so a new venue never inherits the previous venue's
      // since watermark (would cause unchanged no-ops) or batch ordering.
      state._wbLiveSince = '';
      resetLiveCursors();
      if (!options.preserveVenueLabel) state.venueDisplayLabel = '';
      state._wbwForceCalRerender = true;
      try {
        window.__WORKSHOP_SELECTION__ = null;
      } catch (_) {}
      resetDatetimeControlsDom();
      wizardRoot.setAttribute('data-wbw-flow', 'booking');
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = false;
      if (!options.preserveUrl) {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        wizardRoot.__wbwUserReachedDatetime = false;
      }
      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      closeWizardWaitlistModal();
      if (!options.preserveUrl) {
        /* Back / change city means no design is chosen any more. Re-stamping the
           locked variant kept ?variant= alive across cities, so the URL kept
           pointing at a design the visitor had already stepped away from. */
        state.lockedVariantId = '';
        state.focusedVariantId = '';
        updateWizardBookingUrl({ city: '', eventId: '', variantId: '', date: '', step: '' });
      }
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncVenueKindAttr();
      syncSiblingWorkshopPromo();
      updateProductVenueSeoCopy();
    }

    function onVenueResetEvent(e) {
      var detail = (e && e.detail) || {};
      if (detail.bookingRoot && bookingRoot && detail.bookingRoot !== bookingRoot) return;
      /* Inventory search recenter / filter re-render must not re-arm URL auto-advance. */
      if (bookingRoot && bookingRoot.__wbWizardInventoryFilterActive) {
        if (state.branch === 'datetime' || state.branch === 'variants') return;
        clearVenueSelection({ preserveUrl: true, preserveVenueLabel: true });
        return;
      }
      /* Places / geocode search: never re-arm URL deep-link (would jump back to ?venue=). */
      var locSource =
        (typeof window !== 'undefined' &&
          window.__WORKSHOP_LOCATION__ &&
          window.__WORKSHOP_LOCATION__.source) ||
        '';
      if (
        locSource === 'places' ||
        locSource === 'places_autocomplete' ||
        locSource === 'geocode_search'
      ) {
        wizardRoot.__wbwUrlDeepLinkComplete = true;
        if (state.branch === 'datetime' || state.branch === 'variants') return;
        clearVenueSelection();
        return;
      }
      if (urlHasWizardDeepLink() && !wizardRoot.__wbwUserReachedDatetime) {
        wizardRoot.__wbwUrlDeepLinkComplete = false;
        if (state.branch === 'waitlist') {
          state.flow = 'booking';
          wizardRoot.setAttribute('data-wbw-flow', 'booking');
          setBranch('venue');
        }
        clearVenueSelection({ preserveUrl: true, preserveVenueLabel: true });
        return;
      }
      clearVenueSelection();
    }

    function selectVenueCard(card, options) {
      if (!card) return;
      var venue = card._wbVenue;
      if (!venue) return;
      var prevRef = state.selectedVenue
        ? String(state.selectedVenue.venue_ref_id || '').trim()
        : '';
      var nextRef = String(venue.venue_ref_id || '').trim();
      if (prevRef && nextRef && prevRef !== nextRef) {
        stashVenueSession(state.selectedVenue);
        state.slotList = [];
        state.daysWithEvents = {};
        state.selectedDate = '';
        state.selectedSlot = null;
        state.variantWhen = {};
        state.variantQty = {};
        state.focusedVariantId = '';
        state.lockedVariantId = '';
        state.lbEditVariant = '';
        state.lbApplyAll = null;
        state.lbAskApply = false;
        state.viewMonth = new Date();
        state._wbwUserPickedCalDate = false;
        state._wbLiveSince = '';
        resetLiveCursors();
        state._wbwForceCalRerender = true;
        state._wbCalLoadSeq = (state._wbCalLoadSeq || 0) + 1;
        try {
          window.__WORKSHOP_SELECTION__ = null;
        } catch (_) {}
        resetDatetimeControlsDom();
        updateWizardBookingUrl({ eventId: '' });
      }

      wizardRoot.querySelectorAll('.wb-venue-pick-card, .wb-venue-card').forEach(function (c) {
        c.classList.remove('wbw-venue-selected', 'wbw-venue-flipped');
        c.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('wbw-venue-selected');
      card.setAttribute('aria-pressed', 'true');
      if (typeof S.clearMissingControls === 'function') S.clearMissingControls();
      state.selectedVenueCard = card;
      state.selectedVenue = venue;
      state.venueDisplayLabel = resolveVenueDisplayLabel(venue, card);
      state.flow = venueIsWaitlistOnly(venue, card) ? 'waitlist' : 'booking';
      wizardRoot.setAttribute('data-wbw-flow', state.flow);
      syncVenueKindAttr();
      if (bookingRoot) bookingRoot.__wbWizardVenueChosen = true;
      wbwEmitVenueMapSelection(venue);
      syncVenueFlipState();
      /* Do not write ?venue= on Step 1 select — only when entering datetime. */
      updateVenueContinue();
      updateProgressLabels();
      updateBranchTitles();
      syncSiblingWorkshopPromo();
      if (options && options.updatePageCopy) updateProductVenueSeoCopy();
      prefetchVenueCalendar(venue);
    }

    function bindVenueSelection() {
      if (!eventsRoot) return;
      eventsRoot.addEventListener('click', function (e) {
        if (e.target.closest('[data-wbw-wl-signup]')) {
          e.preventDefault();
          e.stopPropagation();
          var wlCard = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
          if (wlCard && wlCard._wbVenue) selectVenueCard(wlCard, { updatePageCopy: true });
          openWizardWaitlistModal();
          return;
        }
        if (e.target.closest('[data-wb-waitlist-open]')) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        var card = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
        if (!card || !wizardRoot.contains(card)) return;
        if (!card._wbVenue) return;
        e.preventDefault();
        activateVenueCard(card);
      });
      eventsRoot.addEventListener('pointerover', function (e) {
        var card = e.target.closest('.wb-venue-pick-card, .wb-venue-card');
        if (!card || !wizardRoot.contains(card) || !card._wbVenue) return;
        if (card.__wbwCalPrefetched) return;
        card.__wbwCalPrefetched = true;
        prefetchVenueCalendar(card._wbVenue);
      });
      eventsRoot.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var card = e.target.closest('.wb-venue-pick-card[role="button"], .wb-venue-card[role="button"]');
        if (!card || !wizardRoot.contains(card) || !card._wbVenue) return;
        if (e.target.closest('[data-wbw-wl-signup]')) return;
        e.preventDefault();
        activateVenueCard(card);
      });
      wizardRoot.querySelectorAll('[data-wbw-wl-modal-dismiss]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          closeWizardWaitlistModal();
        });
      });
      document.addEventListener('wbw:open-waitlist-modal', function (e) {
        var d = (e && e.detail) || {};
        if (d.bookingRoot && bookingRoot && d.bookingRoot !== bookingRoot) return;
        openWizardWaitlistModal();
      });
    }

    function startWaitlistStep() {
      var step = stepEl('waitlist');
      if (!step) return;
      updateBranchTitles();
      var err = step.querySelector('[data-wbw-wl-error]');
      var ok = step.querySelector('[data-wbw-wl-success]');
      if (err) err.hidden = true;
      if (ok) ok.hidden = true;
      setBranch('waitlist');
    }

    function goToNextFromVenue(opts) {
      opts = opts || {};
      rebindSelectedVenueCard();
      if (!state.selectedVenue || !String(state.selectedVenue.venue_ref_id || '').trim()) {
        clearVenueSelection();
        if (opts.userInitiated) {
          if (typeof S.showWizardNotice === 'function') S.showWizardNotice('Choose a city to continue');
          if (typeof S.showWizardAlert === 'function') S.showWizardAlert('Choose a city to continue');
          if (typeof S.flagMissingControl === 'function') {
            S.flagMissingControl(
              wizardRoot.querySelector('[data-wbw-hub-cities]') || eventsRoot
            );
          }
        }
        return;
      }
      if (state.flow === 'waitlist' || state.selectedVenue.has_events !== true) return;
      if (typeof S.clearWizardNotice === 'function') S.clearWizardNotice();
      var start = isStoreVenue(state.selectedVenue) ? startDatetimeStep : startPopupBookingStep;
      return Promise.resolve()
        .then(function () {
          return start();
        })
        .then(function () {
          if (opts.userInitiated && typeof S.scrollWizardIntoView === 'function') {
            S.scrollWizardIntoView();
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          try {
            console.warn('[wbw] continue from venue failed', err);
          } catch (_) {}
          if (isStoreVenue(state.selectedVenue)) {
            setDatetimeCalLoading(true, "Couldn't load dates. Try again.");
          } else {
            setPopupDatetimeLoading(false);
            setPopupDatetimeHint("Couldn't load dates. Try again.", true);
          }
        });
    }

    function activateVenueCard(card) {
      if (!card || !card._wbVenue) return;
      selectVenueCard(card, { updatePageCopy: true });
      if (
        card.getAttribute('data-wb-waitlist-venue') === '1' ||
        card._wbVenue._wbWaitlistVenue === true
      ) {
        return;
      }
      return goToNextFromVenue();
    }

      S.findVenueCardByRef = findVenueCardByRef;
      S.rebindSelectedVenueCard = rebindSelectedVenueCard;
      S.updateVenueContinue = updateVenueContinue;
      S.syncVenueFlipState = syncVenueFlipState;
      S.closeWizardWaitlistModal = closeWizardWaitlistModal;
      S.openWizardWaitlistModal = openWizardWaitlistModal;
      S.wbwEmitVenueMapSelection = wbwEmitVenueMapSelection;
      S.venueSessionKey = venueSessionKey;
      S.clonePlainMap = clonePlainMap;
      S.peekVenueSession = peekVenueSession;
      S.stashVenueSession = stashVenueSession;
      S.applySavedVenueSession = applySavedVenueSession;
      S.clearVenueSelection = clearVenueSelection;
      S.onVenueResetEvent = onVenueResetEvent;
      S.selectVenueCard = selectVenueCard;
      S.bindVenueSelection = bindVenueSelection;
      S.startWaitlistStep = startWaitlistStep;
      S.goToNextFromVenue = goToNextFromVenue;
      S.activateVenueCard = activateVenueCard;
    }
  };
})(typeof window !== "undefined" ? window : this);
